import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { HomeSidebar, HomeTopBar } from './HomeHubParts';
import styles from './HomeHub.module.css';

/**
 * Puts commerce and account pages on the same sidebar + workspace switcher
 * as Home and the company app. Notifications stay on Home; these pages only
 * need navigation.
 */
export default function HubPageShell({ title, children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className={styles.hubRoot}>
      <HomeSidebar
        open={navOpen}
        onClose={() => setNavOpen(false)}
        activePath={location.pathname}
        onNavigate={(to) => {
          setNavOpen(false);
          navigate(to);
        }}
      />
      <div className={styles.hubMain}>
        <HomeTopBar
          title={title}
          onMenu={() => setNavOpen(true)}
          showNotifications={false}
        />
        <div className={styles.hubContent}>{children}</div>
      </div>
    </div>
  );
}
